<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_openDownloadHcExcelTemplate">
          <i class="el-icon-download"></i>模板
        </el-button>
      </div>

      <el-form label-position="left" label-width="120px" class="text-left">
        <el-form-item label="选择文件">
          <el-upload class="upload-demo" ref="upload" action="#" :auto-upload="false" :on-change="getExcelTemplate"
            :file-list="fileList" accept=".xls,.xlsx">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ productImportInfo.excelTemplate === '' ? '必填，请选择数据文件' : productImportInfo.excelTemplate.name }}
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="productImportInfo.remark" placeholder="请填写备注信息" :rows="3"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <el-row>
      <el-col :span="22"></el-col>
      <el-col :span="2">
        <el-button type="primary" @click="_importData" style="margin-bottom: 10px; float: right">
          <i class="el-icon-upload"></i>导入
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { uploadProductImport } from '@/api/goods/productImportApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ProductImport',
  data() {
    return {
      productImportInfo: {
        shopId: '',
        excelTemplate: '',
        remark: ''
      },
      fileList: []
    }
  },
  created() {
    let shopId = this.getShopId();
    this.productImportInfo.shopId = shopId
  },
  methods: {
    productImportValidate() {
      if (!this.productImportInfo.excelTemplate) {
        this.$message.error('文件不能为空')
        return false
      }
      if (!this.productImportInfo.shopId) {
        this.$message.error('还未入驻小区，请先入驻小区')
        return false
      }
      return true
    },
    _openDownloadHcExcelTemplate() {
      window.open('/import/hcmall.xlsx')
    },
    getExcelTemplate(file) {
      this.productImportInfo.excelTemplate = file.raw
    },
    async _importData() {
      if (!this.productImportValidate()) {
        return
      }

      if (!this.checkFileType(this.productImportInfo.excelTemplate.name.split('.')[1])) {
        this.$message.error('不是有效的Excel格式')
        return
      }

      if (!this.checkFileSize(this.productImportInfo.excelTemplate.size)) {
        this.$message.error('Excel文件大小不能超过2M')
        return
      }

      const formData = new FormData()
      formData.append('uploadFile', this.productImportInfo.excelTemplate)
      formData.append('shopId', this.productImportInfo.shopId)
      formData.append('importAdapt', 'importProduct')

      try {
        const res = await uploadProductImport(formData)
        console.log(res)
        this.$message.success('处理成功')
        this.$router.push('/pages/goods/productManage')
      } catch (error) {
        this.$message.error(error || '导入失败')
      }
    },
    checkFileType(fileType) {
      const acceptTypes = ['xls', 'xlsx']
      return acceptTypes.includes(fileType)
    },
    checkFileSize(fileSize) {
      const MAX_SIZE = 2 * 1024 * 1024 // 2M
      return fileSize <= MAX_SIZE
    },
    getShopId() {
      console.log('getShopId');
      return getShopId()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}
</style>